import { Popper, Paper, ClickAwayListener } from "@mui/material";

function PopperComponent({
  open,
  anchorEl,
  onClose,
  children,
  zIndex = 1400,
  minWidth = "11.25rem",
  maxHeight = "18.75rem",
  fontFamily = "inherit",
  paperSx = {},
  paperProps = {},
  ...rest
}: any) {
  return (
    <Popper open={open} anchorEl={anchorEl} style={{ zIndex }} {...rest}>
      <ClickAwayListener onClickAway={onClose}>
        <Paper
          onMouseLeave={onClose}
          sx={{
            border: "1px solid #ECF3FE",
            backgroundColor: "#FFFFFF",
            boxShadow: "0.25rem 0.25rem 0.9375rem rgba(65, 92, 171, 0.15)",
            minWidth,
            maxHeight,
            overflowY: "auto",
            fontFamily,
            "& *": { fontFamily: "inherit" },
            ...paperSx,
          }}
          {...paperProps}
        >
          {children}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
}

export default PopperComponent;
